import { render, staticRenderFns } from "./PostTitle.vue?vue&type=template&id=0e8e7450&"
import script from "./PostTitle.vue?vue&type=script&lang=js&"
export * from "./PostTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports